import { render, staticRenderFns } from "./ClientUserView.vue?vue&type=template&id=0cb6c4bc&scoped=true"
import script from "./ClientUserView.vue?vue&type=script&lang=js"
export * from "./ClientUserView.vue?vue&type=script&lang=js"
import style0 from "./ClientUserView.vue?vue&type=style&index=0&id=0cb6c4bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb6c4bc",
  null
  
)

export default component.exports